import axios from "axios";
import { api } from "./VaultApi";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL;

export const handleSession = () => {
  const userId = window.sessionStorage.getItem("USER_ID");
  const userName = window.sessionStorage.getItem("user_name");

  return { userId, userName };
};

export const loginApi = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const AdminVaultLogin = async (values) => {
  const user = handleSession();
  const url = `${apiUrl}/v1/vault/login`;
  const payload = {
    email: values.email,
    password: values.password,
    user_id: user.userId,
    user_name: user.userName,
  };
  try {
    const response = await loginApi.post(url, payload);
    console.log("Login Values: 1", response?.data.challengeId);
    return response?.data;
  } catch (err) {
    console.error("login failed", err);
    toast.error(err?.response.data.message);
  }
};

export const AdminVaultOtp = async (
  otpValue,
  challengeId,
  setIsVaultAuthenticated,
) => {
  const user = handleSession();
  const url = `${apiUrl}/v1/vault/verify-otp`;
  const payload = {
    challengeId: challengeId,
    otp: otpValue,
    user_id: user.userId,
    user_name: user.userName,
  };
  try {
    const response = await loginApi.post(url, payload);
    setIsVaultAuthenticated(true);
    console.log(response, "otp res");
    return response?.data;
  } catch (err) {
    console.error("otp failed", err);
    toast.error(err?.response.data.message);
  }
};

export const AdminVaultLogout = async () => {
  const user = handleSession();
  const url = `${apiUrl}/v1/vault/logout/${user?.userId}/${user?.userName}`;
  try {
    const response = await api.get(url);
    return response?.data;
  } catch (err) {
    console.error("logout failed", err);
    // toast.error(err?.response.data.message)
  }
};

export const AdminVaultLogoutAll = async () => {
  const user = handleSession();
  const url = `${apiUrl}/v1/vault/logout-all/${user?.userId}/${user?.userName}`;
  try {
    const response = await api.get(url);
    return response?.data;
  } catch (err) {
    console.error("logout all failed", err);
    // toast.error(err?.response.data.message)
  }
};

export const AdminVaultRefreshToken = async () => {
  const user = handleSession();
  const url = `${apiUrl}/v1/vault/refresh-token/${user?.userId}/${user?.userName}`;
  try {
    const response = await api.post(url);
    console.log("refresh api run");

    return response?.data;
  } catch (err) {
    console.error("refresh access token failed", err);
  }
};

export const AdminVaultAuthMe = async (setIsVaultAuthenticated, setLoading) => {
  const url = `${apiUrl}/v1/vault/authme`;
  setLoading(true);
  try {
    const response = await api.get(url);
    setIsVaultAuthenticated(true);
    return response?.data;
  } catch (err) {
    console.error("access token missing", err);
    setIsVaultAuthenticated(false);
    return err?.response?.data;
  } finally {
    setLoading(false);
  }
};

export const AdminVaultForgotPass = async (values,setShowOtpScreen,setForgotFormData,setShowForgotPass) => {
  const user = handleSession();
  const url = `${apiUrl}/v1/vault/forgotpassword`;
  const payload = {
    email: values.email,
    newPassword: values.password,
    user_id: user.userId,
    user_name: user.userName,
  };
  try {
    const response = await loginApi.post(url, payload);
    setShowOtpScreen(true)
        setShowForgotPass(false)
    console.log("Login Values: 1", response?.data.challengeId);
    return response?.data;
  } catch (err) {
    setForgotFormData({
    email: "",
    password: "",
  })
    console.error("login failed", err);
    toast.error(err?.response.data.message);
  }
};

export const AdminVaultUpdatePassOtpVerify = async (
  values,
  otpValue,
  challengeId,
) => {
  const user = handleSession();
  const url = `${apiUrl}/v1/vault/password-resets/verify-otp`;
  const payload = {
    email: values.email,
    newPassword: values.password,
    user_id: user.userId,
    user_name: user.userName,
    otp: otpValue,
    challengeId: challengeId,
  };
  try {
    const response = await loginApi.post(url, payload);
    console.log(response, "otp res");
    toast.success(response?.data.message)
    return response?.data;
  } catch (err) {
    console.error("otp failed", err);
    toast.error(err?.response.data.message);
  }
};
